'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of personal care
 */ const PersonalCare = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3792_5064)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.282 29.7764H63.6466C64.4306 29.7764 65.0673 30.4127 65.0673 31.1962V34.3196H50.8613V31.1962C50.8613 30.4127 51.498 29.7764 52.282 29.7764Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M60.2378 21.543H55.6919V29.7774H60.2378V21.543Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M46.5459 34H68.7068C71.2158 34 73.2528 36.0357 73.2528 38.5432V83.6907C73.2528 85.2578 71.9799 86.5304 70.4114 86.5304H43.4207C42.6367 86.5304 42 85.8941 42 85.1106V38.5432C42 36.0357 44.0369 34 46.5459 34Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M62.227 17H48.4634C48.0865 17 47.7254 17.1498 47.459 17.416L44.6606 20.2128C44.2167 20.6564 44.2167 21.3756 44.6606 21.8192L46.2679 23.4256C46.7118 23.8693 47.4314 23.8693 47.8753 23.4256L49.7583 21.5437H62.2275C63.012 21.5437 63.6482 20.9079 63.6482 20.1239V18.4199C63.6482 17.6358 63.012 17 62.2275 17H62.227Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M49.0728 77.9127H35.6524C34.625 77.9127 33.7668 77.1307 33.6722 76.1085L30.998 47.2463V44.123C30.998 43.3389 31.6342 42.7031 32.4187 42.7031H52.307C53.0915 42.7031 53.7277 43.3389 53.7277 44.123V47.2463L51.0535 76.1085C50.9589 77.1307 50.1007 77.9127 49.0733 77.9127H49.0728Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M44.7728 62.4339C46.1043 61.1032 46.1043 58.9456 44.7728 57.6149C43.4413 56.2842 41.2825 56.2842 39.951 57.6149C38.6194 58.9456 38.6194 61.1032 39.951 62.4339C41.2825 63.7646 43.4413 63.7646 44.7728 62.4339Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M35.9702 77.9128H48.7555V85.0116C48.7555 86.1084 47.8641 86.9993 46.7666 86.9993H37.9591C36.8616 86.9993 35.9702 86.1084 35.9702 85.0116V77.9128Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M50.0332 47.2461C50.0332 46.7758 49.6517 46.394 49.1807 46.394H35.5434C35.0729 46.394 34.6909 46.7753 34.6909 47.2461C34.6909 47.7168 35.0724 48.0981 35.5434 48.0981H49.1812C49.6517 48.0981 50.0337 47.7168 50.0337 47.2461H50.0332Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M44.2095 81.604H40.5161C40.0456 81.604 39.6636 81.9853 39.6636 82.456C39.6636 82.9267 40.0451 83.308 40.5161 83.308H44.2095C44.68 83.308 45.062 82.9267 45.062 82.456C45.062 81.9853 44.6805 81.604 44.2095 81.604Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M47.7613 59.1726H46.539C46.428 58.6298 46.2132 58.1243 45.9166 57.6771L46.7824 56.8118C47.1154 56.4791 47.1154 55.9399 46.7824 55.6071C46.45 55.2744 45.91 55.2744 45.577 55.6071L44.7112 56.4724C44.2642 56.176 43.7585 55.9613 43.2148 55.8504V54.6289C43.2148 54.1587 42.8333 53.7769 42.3623 53.7769C41.8913 53.7769 41.5098 54.1581 41.5098 54.6289V55.8504C40.9667 55.9613 40.4609 56.176 40.0134 56.4724L39.1476 55.6071C38.8152 55.2744 38.2751 55.2744 37.9422 55.6071C37.6093 55.9399 37.6093 56.4791 37.9422 56.8118L38.808 57.6771C38.5114 58.1238 38.2966 58.6293 38.1856 59.1726H36.9634C36.4929 59.1726 36.1108 59.5539 36.1108 60.0246C36.1108 60.4953 36.4924 60.8766 36.9634 60.8766H38.1856C38.2966 61.4194 38.5114 61.9249 38.808 62.3721L37.9422 63.2374C37.6093 63.5701 37.6093 64.1094 37.9422 64.4421C38.1084 64.6087 38.3268 64.6915 38.5446 64.6915C38.7625 64.6915 38.9809 64.6082 39.1471 64.4421L40.0129 63.5768C40.4599 63.8732 40.9657 64.0879 41.5093 64.1988V65.4204C41.5093 65.8906 41.8908 66.2724 42.3618 66.2724C42.8328 66.2724 43.2143 65.8911 43.2143 65.4204V64.1988C43.7574 64.0879 44.2632 63.8732 44.7107 63.5768L45.5765 64.4421C45.7427 64.6087 45.9611 64.6915 46.179 64.6915C46.3968 64.6915 46.6152 64.6082 46.7814 64.4421C47.1143 64.1094 47.1143 63.5701 46.7814 63.2374L45.9156 62.3721C46.2122 61.9254 46.427 61.4199 46.538 60.8766H47.7602C48.2307 60.8766 48.6128 60.4953 48.6128 60.0246C48.6128 59.5539 48.2313 59.1726 47.7602 59.1726H47.7613ZM42.3628 62.5801C40.9529 62.5801 39.8058 61.4337 39.8058 60.0246C39.8058 58.6155 40.9529 57.4691 42.3628 57.4691C43.7728 57.4691 44.9199 58.6155 44.9199 60.0246C44.9199 61.4337 43.7728 62.5801 42.3628 62.5801Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3792_5064",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "44.5913",
                        height: "70",
                        fill: "white",
                        transform: "translate(29 17)"
                    })
                })
            })
        ]
    });
};

exports.PersonalCare = PersonalCare;
//# sourceMappingURL=PersonalCare.cjs.map
